// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-title[data-v-6c214a78] {\n  margin-top: -27vh;\n}", "",{"version":3,"sources":["webpack://./resources/ts/frontend/components/PagesTitle.vue"],"names":[],"mappings":"AACA;EACI,iBAAA;AAAJ","sourcesContent":["\r\n.pages-title {\r\n    margin-top: -27vh;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
